import basex from "base-x";

const bs58 = basex("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
const encoder = new TextEncoder();
const decoder = new TextDecoder();

/**
 * Encode a string t a base58 string.
 *
 * @param text The string to encode
 */
export const base58Encode = (text: string): string => {
  return bs58.encode(encoder.encode(text));
};

/**
 * Decode a string from a base58 string.
 *
 * @param encodedText The encoded string.
 */
export const base58Decode = (encodedText: string): string => {
  return decoder.decode(bs58.decode(encodedText));
};
